import { getCssBackgroundFromBorderColor } from '../theme/cssBackgroundBorderColor.js';
import { css, styled } from 'styled-components';

const variants = {
  thin: css([
    `height:0.5px;`
  ]),
  default: css([
    `height:1px;`
  ])
};
const Divider = styled.hr.withConfig({
  displayName: "Divider",
  componentId: "sc-ff73dc26-0"
})([
  `width:100%;`,
  `;flex-shrink:0;`,
  ` border:none !important;`
], ({ variant = "default" }) => variants[variant], getCssBackgroundFromBorderColor("primary"));

export { Divider as default };
//# sourceMappingURL=Divider.js.map
